<style scoped lang="scss">
.main .col-xs-9.content-body .new-title {
  margin-top: 18px;
  margin-left: 58px
}

.new-title .title-bg {
  position: relative;
  margin-top: 12px;
  padding: 2px 30px
}

.new-title .title-bg:before {
  content: '';
  position: absolute;
  display: inline-block;
  height: 20px;
  width: 20px;
  top: 5px;
  left: 0;
  background: #000
}

.sitemap-content {
  margin-left: 58px
}

.sitemap-content .content-item {
  position: relative
}

.sitemap-content .content-item h2 {
  color: #333;
  font-size: 20px;
  margin-left: 20px;
  margin-top: 30px;
  margin-bottom: 20px
}

.sitemap-content .content-item h2:before {
  content: '';
  display: inline-block;
  height: 10px;
  width: 10px;
  background: #000;
  position: absolute;
  left: 0;
  top: 8px;
}

.sitemap-content .content-item .item-list {
  display: flex
}

.sitemap-content .content-item .item-list .title {
  margin-bottom: 8px;
  font-size: 14px
}

.sitemap-content .content-item .item-list ul {
  padding: 0;
  list-style: none;
  margin-left: 20px;
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.sitemap-content .content-item .item-list ul li {
  margin-bottom: 8px;
}

.sitemap-content .position h3::before {
  top: 28px
}

.sitemap-content .position ul {
  width: 275px !important
}

.sitemap-content .dashed {
  height: 10px;
  border-bottom: 1px dashed #dcdcdc
}

.sitemap-content .about {
  width: 100% !important;
  display: inline-flex;
  flex-wrap: wrap
}

.sitemap-content .about li {
  margin-right: 240px
}

.sitemap-content .about li:nth-of-type(3),
.sitemap-content .about li:nth-of-type(6) {
  margin-right: 0
}
.product-map{
  display: block !important;
  li{
    height: 320px;
    margin-right:20px;
    padding-right: 15px;
    margin-block: 20px;
    overflow-y: auto;
    float: left;
    
  }
}
</style>
<style scoped>
@media screen and (max-width: 641px){
  .wrap-summary .breads{
    display: none!important;
  }
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .new-title {
    margin-left: 0!important;
  }
  .sitemap-content{
    margin-left: 0!important;
  }
  .container {
    width: 90% !important;
  }
  .sitemap-content .content-item .item-list ul{
    display: block!important;
  }
}
@media screen and (max-width: 640px) {

  .container {
    font-size: 12px !important;
  }
}
</style>
<template>
  <div>
    <div class="wrap wrap-summary">
      <div class="breads container"
           style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;margin-top: 20px;">
        <bread></bread>
      </div>
      <div class="container">
        <div>
          <div class="new-title mb13">
            <div class="title-bg mt0">
              <h1>站点地图</h1>
            </div>
          </div>
          <div class="sitemap-content">
            <div class="dashed"></div>
            <div class="content-item">
              <h2 v-for="(item, index) in pageDataNew.menu">
                <a :href="item.to" style="color: #014492"><strong>{{ item.label }}</strong></a>
              </h2>
            </div>
            <div class="dashed"></div>
          </div>
          <div class="sitemap-content">
            <div class="content-item" v-for="(item, index) in pageDataNew.products">
              <h2>
                <a :href="item.to" style="color: #014492"><strong>{{ item.label }}</strong></a>
              </h2>
              <div class="item-list">
                <ul v-if="item.subMenu" class="product-map">
                  <template v-for="(itx, idx) in item.subMenu">
                      <li :key="idx+'productsOne'">
                        <div style="font-size: 18px;font-weight:bold;margin-bottom: 10px;">
                          <a :href="itx.to" style="color: #014492;">{{ itx.label }}</a>
                        </div>
                        <div v-for="(it, i) in itx.children" :key="i+'productsTwo'" v-show="!it.children"
                            style="font-size: 16px;margin-bottom: 10px;">
                          <a :href="it.to" style="color: #014492;">{{ it.label }}</a>
                        </div>
                        <div v-show="it.children" v-for="(it, i) in itx.children" :key="i+'productsThree'">
                          <div @click="getClickList(it.label);showContent=!showContent">
                            <div style="font-size: 16px;margin-bottom: 10px;">
                              <a :href="it.to" style="color: #014492;">{{ it.label }}</a>
                            </div>
                          </div>
                          <div>
                            <div v-for="(its, i) in it.children" :key="i+'productsFour'"
                                style="margin-bottom: 10px;font-size: 14px">
                              <a :href="its.to" style="padding-left:10px;color: #014492;">{{ its.label }}</a>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li v-if="idx==6" :key="'molecularReagentMenu'+idx">
                        <div style="font-size: 18px;font-weight:bold;margin-bottom: 10px;">
                           <a :href="molecularReagentMenu[0].to" style="color: #014492;">{{ molecularReagentMenu[0].label }}</a>
                        </div>
                        <div v-for="(its, i) in molecularReagentMenu[0].subMenu" :key="'molecularReagentMenuEl'+i" style="margin-bottom: 10px;font-size: 14px">
                          <a :href="its.to" style="font-size: 16px;color: #014492;">{{ its.label }}</a>
                        </div>
                      </li>
                  </template>
                  
                </ul>
              </div>
            </div>
            <div class="dashed"></div>
          </div>
          <div class="sitemap-content">
            <div class="content-item" v-for="(item, index) in pageDataNew.equipment">
              <h2>
                <a :href="item.to" style="color: #014492"><strong>{{ item.label }}</strong></a>
              </h2>
              <div class="item-list">
                <ul v-if="item.subMenu">
                  <li v-for="(itx, idx) in item.subMenu" :key="idx+'equipmentOne'">
                    <div style="font-size: 18px;font-weight:bold;margin-bottom: 10px;">
                      <a :href="itx.to" style="color: #014492;">{{ itx.label }}</a>
                    </div>
                    <div v-for="(it, i) in itx.children" :key="i+'equipmentTwo'" v-show="!it.children"
                         style="font-size: 16px;margin-bottom: 10px;">
                      <a :href="it.to" style="color: #014492;" v-if="!it.ref">{{ it.label }}</a>
                      <a v-else-if="it.ref" :href="it.ref" style="color: #014492;">{{ it.label }}</a>
                    </div>
                    <div v-show="it.children" v-for="(it, i) in itx.children" :key="i+'equipmentThree'">
                      <div @click="getClickList(it.label);showContent=!showContent">
                        <div style="font-size: 16px;margin-bottom: 10px;">
                          <a :href="it.to" style="color: #014492;">{{ it.label }}</a>
                        </div>
                      </div>
                      <div>
                        <div v-for="(its, i) in it.children" :key="i+'equipmentFour'"
                             style="margin-bottom: 10px;font-size: 14px">
                          <a :href="its.to" style="padding-left:10px;color: #014492;" v-if="!its.ref">{{ its.label }}</a>
                          <a v-else-if="its.ref" :href="its.ref" style="color: #014492;">{{ its.label }}</a>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="dashed"></div>
          </div>
          <div class="sitemap-content">
            <div class="content-item">
              <h2 v-for="(item, index) in pageDataNew.biology">
                <a :href="item.to" style="color: #014492"><strong>{{ item.label }}</strong></a>
              </h2>
            </div>
            <div class="dashed"></div>
          </div>
          <div class="sitemap-content">
            <div class="content-item">
              <h2 v-for="(item, index) in pageDataNew.resource">
                <a :href="item.to" style="color: #014492"><strong>{{ item.label }}</strong></a>
              </h2>
            </div>
            <div class="dashed"></div>
          </div>
          <div class="sitemap-content">
            <div class="content-item" v-for="(item, index) in pageDataNew.summary">
              <h2>
                <a :href="item.to" style="color: #014492"><strong>{{ item.label }}</strong></a>
              </h2>
              <div class="item-list">
                <ul v-if="item.subMenu">
                  <li v-for="(itx, idx) in item.subMenu" :key="idx+'summaryOne'">
                    <div style="font-size: 18px;font-weight:bold;margin-bottom: 10px;">
                      <a :href="itx.to" style="color: #014492;">{{ itx.label }}</a>
                    </div>
                    <div v-for="(it, i) in itx.children" :key="i+'summaryTwo'" v-show="!it.children"
                         style="font-size: 16px;margin-bottom: 10px;">
                      <a :href="it.to" style="color: #014492;display: none" v-if="it.disabled">{{ it.label }}</a>
                      <a :href="it.to" style="color: #014492;" v-else>{{ it.label }}</a>
                    </div>
                    <div v-show="it.children" v-for="(it, i) in itx.children" :key="i+'summaryThree'">
                      <div @click="getClickList(it.label);showContent=!showContent">
                        <div style="font-size: 16px;margin-bottom: 10px;">
                          <a :href="it.to" style="color: #014492;">{{ it.label }}</a>
                        </div>
                      </div>
                      <div>
                        <div v-for="(its, i) in it.children" :key="i+'summaryFour'"
                             style="margin-bottom: 10px;font-size: 14px">
                          <a :href="its.to" style="padding-left:10px;color: #014492;">{{ its.label }}</a>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="dashed"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import 'babel-polyfill'
import bread from "@/components/bread"
import { productCategories } from '@/services/api.index'
export default {
  components: {
    bread
  },
  data() {
    return {
      title: '',
      showContent: false,
      molecularReagentMenu: []
    }
  },
  watch: {
    title: {
      immediate: true,
      handler(data) {
        console.log('data', data)
        this.showContent = true
      }
    }
  },
  computed: {
    ...mapState(['pageDataNew']),
    defaultActive() {
      return decodeURIComponent(this.$route.fullPath)
    }
  },
  mounted() {
    this.getMolecularCategories()
  },
  methods: {
    getClickList(label) {
      this.title = label
    },
   getMolecularCategories() {
      this.molecularReagentMenu = _.cloneDeep(this.pageDataNew.molecularReagent)
      this.molecularReagentMenu[0].subMenu = []
      const that = this
      productCategories('', 1).then((res) => {
        console.info('MOLECULAR CATE.', res)
        res.data.map((item) => {
          // 产品需求，暂时没有判断是否跳商城的flag，如果修改名称这里需同样修改名称（坑）
          if(item.name === '培养基系列') {
            that.molecularReagentMenu[0].subMenu.push({
              label: item.name,
              to: process.env.SHOP_URL + 'product/list/846?productTagsId=&brandId=154&promotionId=&orderType=&promotionPluginId=&startPrice=&endPrice='
            })
            return
          }
          that.molecularReagentMenu[0].subMenu.push({
            label: item.name,
            to: `/molecular-reagent?id=${item.id}&name=${item.name}`
          })
        })
        console.info('MENU UPDATED.', this.molecularReagentMenu)
      })
    },
  }
  
}
</script>



// WEBPACK FOOTER //
// src/views/TsingMap/index.vue